export default __webpack_public_path__ + "static/media/Hello Space.0ba9ddcb.png";